import {PageEnums} from "components/nav/PageEnums";

declare var $:any;

import * as React from 'react';
import { PageWrapper } from 'components/widgets/PageWrapper';
import { searchDataSource } from 'data/SearchDataSource';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import { FeedItemContent } from './feed/FeedItem/FeedItemContent';
import { Search } from './widgets/Search';
import {UIState} from "../data/UIState";
import {Transport} from "data/transport";
import {HeaderLevelCorrectedContent} from "components/feed/FeedItem/HeaderLevelCorrectedContent";


interface IPageProps {
	nav:any;
}

interface Props extends IPageProps {
	searchText:string;
}

@observer
export class LibraryPage extends React.Component<Props> {
	@observable posts:Array<any> = [];
	@observable searchText:string = '';

	componentDidMount(){
    searchDataSource.addListener(this.handleSearchDataChange);
    this.handleSearchDataChange();
	}
	
  componentWillUnmount() {
    searchDataSource.removeListener(this.handleSearchDataChange);
	}
	
  componentWillReceiveProps(nextProps) {		
  	if(nextProps.searchText!=this.props.searchText){
  		this.handleSearchDataChange();
  	}
	}
	
  handleSearchDataChange = () => {
		this.searchText = searchDataSource.getSearchText();
	}
	
	componentWillMount(){
		// TODO: move this to a datastore
  	$.ajax({
      contentType:"application/json; charset=utf-8",
      dataType:'json',
      headers: { 'Authorization':'Token '+localStorage.getItem('token') },
      type:'GET',
      url: Transport.URL("/library/"+UIState.feedData.solution._id)
    })
    .done((posts)=>{
    	this.posts = posts;
    })
    .fail( (jqXHR, textStatus, errorThrown )=>{
      alert('Library failed to load. This may be due to a network error or lack of Internet. Please try again.');
    });
	}

	@computed
	get filteredPosts() {
		if(this.searchText && this.searchText.length > 0){
			return this.posts.filter((post,i,all) => {
				const postSearchContent = post.title.toLowerCase();
				return postSearchContent.indexOf(this.searchText.toLowerCase()) >= 0;
			});
		} else {
			return this.posts;
		}
	}

	render() {
		return (
			<div>
				{this.props.nav}
				<PageWrapper
					pageEnum={PageEnums.library}
				>
					<Search text="Search" />

					{
						this.searchText?
						<h2 className="content-title">{this.filteredPosts.length} MATCH{this.filteredPosts.length!=1?"ES":""} FOUND FOR "{this.searchText}"</h2>
						:
						<h2 className="content-title">LATEST FROM LIBRARY</h2>
					}

					{
						this.filteredPosts.map((post, idx) => 
							<LibraryPost key={idx}>
								<i aria-hidden style={{fontFamily:'wellness-concepts'}} className={post.icon ? post.icon : "icon-file-o"}></i>
								<FeedItemContent title={post.title} feedItemContext={'library'}>
									<HeaderLevelCorrectedContent className="text" content={post.content} offset={'library'} />
									{ post.bottomLinkAction && <a className="bottomLinkAction" href={post.bottomLinkAction} aria-label={`Download ${post.title}, opens new tab`} target="_blank">{post.bottomLinkTitle}</a>}
								</FeedItemContent>
							</LibraryPost>
						)
					}
				</PageWrapper>
			</div>
			);
		}
}

const LibraryPost = (props:{children:any}) =>
<div className="post">
	<table>
		<tbody>
			<tr>
				<td className="icon">{props.children[0]}</td>
				<td className="mid">{props.children[1]}</td>
				<td className="right">{props.children[2]}</td>
			</tr>
		</tbody>
	</table>
</div>
;

